import parse from "html-react-parser"
import { useConsole } from "contexts/Console"

import styled from "@emotion/styled"
import { bold } from "css/text"

const List = styled.ul`
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0;
  margin-inline-end: 0;
  padding-inline-start: 2.5rem;
  list-style-type: disc;
`

const Dl = styled.dl``

const Term = styled.dt`
  ${bold}
  font-style: italic;
  display: inline;
`

const Descript = styled.dd`
  display: inline;
  overflow-wrap: break-word;
  b {
    ${bold}
  }

  &::before {
    content: var(--separator);
    display: inline;
    font-style: normal;
    margin-inline: 0.3rem;
  }
  &::after {
    content: "";
    display: inline-block;
    width: 100%;
  }
`

const Li = styled.li``

function DtDd({ term, description }) {
  const console = useConsole()

  return (
    <>
      <Term>{term}</Term>
      <Descript>{parse(description)}</Descript>
    </>
  )
}

export default function LegalDefinitionList({ definition_list, separator, ...rest }) {
  const console = useConsole()

  return (
    definition_list.length > 0 && (
      <List style={{ "--separator": `"${separator}"` }} as={definition_list.length === 1 ? "div" : "ul"}>
        {definition_list.map(({ definition, _metadata }) => (
          <Li key={_metadata.uid} as={definition_list.length === 1 ? "div" : "li"}>
            <Dl>
              {definition.map(({ term, description, _metadata }) => (
                <DtDd key={_metadata.uid} term={term} description={description} />
              ))}
            </Dl>
          </Li>
        ))}
      </List>
    )
  )
}
